<template>
    <templateList
        hide-filters
        page-name="Lista de Equipes"
        search-input-placeholder="Buscar Equipe"
        add-button-text="Adicionar Equipe"
        add-event="users-teams-add"
        search-event="users-teams-search"
        filters-apply-event="filter-list-users-teams"
        clear-filters-event="clear-list-users-teams"
        menu-card-icon="fal fa-cog"
    >
        <template #bradcrumbs>
            <ui-breadcrumbs design="full" :container="false">
                <template #left> Equipes &#8226; Lista de Equipes </template>
            </ui-breadcrumbs>
        </template>

        <template #content>
            <ui-table
                :data="dataComputed"
                :per-page="perPage"
                :columns="tableColumns"
                :loading="loading"
                is-fixed-list
                select-column-menu
                last-col-fixed
                class="scroll-color"
                name="usersTeamsList"
                tr-component="users/teams/table-line"
                not-found-icon="fal fa-user"
                not-found-text="Não foi possível encontrar nenhuma Equipe"
            />

            <ui-pagination
                :pages="lastPageComputed"
                :current="currentPageComputed"
                @previous="previousPageHandler"
                @next="nextPageHandler"
            />

            <ui-sidebar-add />
            <delete-team-modal />
        </template>
    </templateList>
</template>

<script>
	import { uiBreadcrumbs, uiTable, uiPagination } from '@/components/ui'
	import templateList from '@/templates/page-list'
	import uiSidebarAdd from './components/sidebar-add'

	import deleteTeamModal from './components/delete-modal'
	import helpers from '@/mixins/helpers'

	import { team } from '@/services/axios'
	import { storage } from '@/services/storage'

	export default {
		name: 'ui-users-teams',

		components: {
			templateList,
			uiBreadcrumbs,
			uiTable,
			uiPagination,
			uiSidebarAdd,
			deleteTeamModal,
		},
		mixins: [helpers],

		data() {
			return {
				data: {},
				loading: false,
				perPage: 25,
				search: '',
				tableColumns: [
					{
						title: 'Nome da Equipe',
					},
					{
						title: storage.get('label_manager') || 'Gerentes',
						class: 'control-s',
					},
					{
						title: storage.get('label_broker') || 'Corretores',
						class: 'control-s',
					},
					{
						title: 'Atualização',
						class: 'control-lg',
					},
					{
						title: '',
						class: 'control-xs',
					},
				],
			}
		},

		computed: {
			dataComputed() {
				return this.data && this.data.data ? this.data.data : []
			},
			lastPageComputed() {
				return this.data && this.data.last_page ? this.data.last_page : 0
			},
			currentPageComputed() {
				return this.data && this.data.current_page ? this.data.current_page : 0
			},
		},

		beforeMount() {
			/**
			 * Carrega os dados da tabela
			 */
			this.$nextTick(() => {
				this.getData()
			})
		},

		mounted() {
			/**
			 * Abre o Sidebar para se adicionar a Equipe
			 */
			this.$nextTick(() => {
				this.$root.$on('users-teams-add', () => {
					this.showSidebar()
				})
			})

			this.$root.$on('users-teams-search', (data) => {
				this.search = data
				this.getData()
			})
		},

		beforeDestroy() {
			this.$root.$off('users-teams-add')
			this.$root.$off('users-teams-search')
			this.$root.$off('filter-list-users-teams')
			this.$root.$off('clear-list-users-teams')
		},

		methods: {
			/**
			 * Abre o Sidebar para se adicionar o usuário
			 */
			showSidebar() {
				this.$root.$emit('sidebar-open-users-teams-add')
			},

			/**
			 * Carrega os dados da tabela
			 */
			getData(nextPage) {
				this.loading = true
                this.$root.$emit('ui-search-box-loading-true');

				let params = {
					q: this.search || null,
					per_page: this.perPage,
					page: nextPage || null,
				}

				team.getAll('/search/true', params)
					.then((res) => {
						this.data = res && res.data ? res.data : null
						this.$store.dispatch('dataTable/setTotal', res.data.total)
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
					.finally(() => {
						this.loading = false
                        this.$root.$emit('ui-search-box-loading-false');

					})
			},

			/**
			 * Mudar paginação para a próxima página
			 */
			previousPageHandler() {
				this.getData(Number(this.data.current_page) - 1)
			},

			/**
			 * Mudar paginação para a página anterior
			 */
			nextPageHandler() {
				this.getData(Number(this.data.current_page) + 1)
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
